import script from "./VipEquity.vue?vue&type=script&setup=true&lang=ts"
export * from "./VipEquity.vue?vue&type=script&setup=true&lang=ts"

import "./VipEquity.vue?vue&type=style&index=0&id=395617e7&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-395617e7"]])

export default __exports__